<template>
  <div class="column is-6-desktop is-7-widescreen is-5-fullhd dash-timeline is-relative">
    <div class="columns">
      <!--<div class="column is-2 is-paddingless"></div>-->
      <div class="column is-12 is-paddingless-bottom ">
        <div class="has-bg-white is-border">
          <div class="columns is-gapless is-vcentered">
            <div class="column is-padding-left">
              <strong class="is-size-3">Mes tâches</strong>
            </div>
            <div class="column is-tab-like is-narrow is-padding-right-xsmall">
              <span class="tag is-primary is-margin-left-xsmall is-radius-xlarge">{{eventCount}}</span>
            </div>
            <div class="column is-tab-like is-narrow is-padding-right-small">
              <!--<a @click.prevent.stop="refreshEvents"
                 class="button is-white is-min-width-0 is-padding-left-small is-padding-right-small">
                <span class="icon is-small">
                    <i class="fal fa-sync"></i>
                </span>
              </a> -->
              <div class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger">
                  <a class="button is-white is-min-width-0 is-padding-left-small is-padding-right-small">
                    <span class="is-small" aria-haspopup="true"
                          aria-controls="dropdown-menu">
                        <i class="fal fa-filter"></i>
                    </span>
                  </a>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content has-text-left">
                    <div class="control dropdown-item">
                      <input id="options" type="checkbox" name="column" class="is-checkradio is-circle"
                             :value="EVENT_TYPES.OPTION" v-model="displayedEvents">
                      <label for="options">Options</label>
                    </div>
                    <div class="control dropdown-item">
                      <input id="denunciations" type="checkbox" name="column" class="is-checkradio is-circle"
                             :value="EVENT_TYPES.DENUNCIATION" v-model="displayedEvents">
                      <label for="denunciations">Dénonciations</label>
                    </div>
                    <div class="control dropdown-item">
                      <input id="reminders" type="checkbox" name="column" class="is-checkradio is-circle"
                             :value="EVENT_TYPES.REMINDER" v-model="displayedEvents">
                      <label for="reminders">Rappels</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition-group v-if="eventCount > 0 && runningOptionsLoaded && runningDenunciationsLoaded"
                      enter-active-class="animista enter"
                      leave-active-class="animista exit"
                      move-class="transition" tag="div">
      <template v-for="(e) in timeline">
        <div :key="'a' + e.event.pk" v-if="e.showDayLabel"
             class="column is-12 is-paddingless-bottom dash-timeline-date">
          <div class="has-bg-light">
            <strong
              class="is-size-6 is-light is-block is-uppercase is-padding-top-small is-padding-bottom-small is-padding-left">
              {{ e.date | dtFormat('dddd') }} {{ e.date | dtFormat('DD MMMM') }}
            </strong>
          </div>
        </div>
        <div :key="'b' + e.event.pk" class="column is-12 is-paddingless-bottom">
          <option-card :option="e.event" v-if="e.type === EVENT_TYPES.OPTION" @process="processEvent"></option-card>
          <denunciation-card :denunciation="e.event" v-else-if="e.type === EVENT_TYPES.DENUNCIATION"
                             @process="processEvent">

          </denunciation-card>
          <reminder-card :reminder="e.event" v-else-if="e.type === EVENT_TYPES.REMINDER">reminder !</reminder-card>
        </div>
      </template>
    </transition-group>
    <div v-if="eventCount === 0 && runningOptionsLoaded && runningDenunciationsLoaded"
      class="columns is-multiline">
      <div class="column is-12 is-paddingless-bottom">
        <strong class="is-size-6 is-light is-block is-uppercase is-padding-top-small is-padding-bottom-small is-padding-left">
          {{ today | dtFormat('dddd') }} {{ today | dtFormat('DD MMMM') }}
        </strong>
      </div>
      <div class="column is-12 is-paddingless-bottom">
        <div class="box is-white illustrationWrapper">
          <img src="/static/cat.gif">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import OptionCard from './event-card/OptionCard'
  import DenunciationCard from './event-card/DenunciationCard'
  import ReminderCard from './event-card/ReminderCard'
  import moment from 'moment'
  import { orderBy } from 'lodash'

  const EVENT_TYPES = Object.freeze({
    OPTION: 'OPTION',
    DENUNCIATION: 'DENUNCIATION',
    REMINDER: 'REMINDER'
  })

  export default {
    name: 'TodoList',
    props: {},
    components: {
      OptionCard,
      DenunciationCard,
      ReminderCard
    },
    data () {
      return {
        EVENT_TYPES: EVENT_TYPES,
        displayedEvents: [EVENT_TYPES.OPTION, EVENT_TYPES.DENUNCIATION, EVENT_TYPES.REMINDER],
        processed: []
      }
    },
    computed: {
      ...mapState([
        'runningOptions', 'runningDenunciations', 'runningDenunciationsLoaded', 'runningOptionsLoaded'
      ]),
      ...mapGetters([
        'pendingOptions', 'reminders'
      ]),
      today () {
        return moment()
      },
      enterClass () {
        if (this.eventCount > 0) {
          return 'animista enter'
        } else {
          return ''
        }
      },
      eventCount () {
        return this.events.length
      },
      options () {
        return this.rawEvents.filter(x => {
          return x.type === EVENT_TYPES.OPTION
        })
      },
      timeline () {
        let timeline = []
        return this.events.map(x => {
          let date = moment(x.date).format('DD/MM/YYYY')
          if (timeline.includes(date) === false) {
            this.$set(x, 'showDayLabel', true)
            timeline.push(date)
          }
          return x
        }).filter(x => {
          return this.displayedEvents.includes(x.type)
        })
      },
      events () {
        let events = []

        const okStatus = ['pending']

        this.runningOptions
          .filter(x => {
            return okStatus.includes(x.status) || this.processed.includes(x.pk)
          })
          .forEach(x => {
            let wrapper = {
              event: Object.assign({}, x),
              type: EVENT_TYPES.OPTION,
              date: x.created_on,
              showDayLabel: false
            }
            events.push(wrapper)
          })

        this.runningDenunciations
          .filter(x => {
            return okStatus.includes(x.status) || this.processed.includes(x.pk)
          })
          .forEach(x => {
            let wrapper = {
              event: Object.assign({}, x),
              type: EVENT_TYPES.DENUNCIATION,
              date: x.created_on,
              showDayLabel: false
            }
            events.push(wrapper)
          })

        this.reminders
          .filter(x => {
            const today = moment().startOf('day')
            return moment(x.date).isSame(today, 'd')
          })
          .forEach(x => {
            let wrapper = {
              event: Object.assign({}, x),
              type: EVENT_TYPES.REMINDER,
              date: x.date,
              showDayLabel: false
            }
            events.push(wrapper)
          })

        return orderBy(events, x => {
          return moment(x.date)
        }, 'desc')
      }
    },
    methods: {
      processEvent (event) {
        this.processed.push(event.pk)
      },
      refreshEvents () {
        this.$emit('refreshEvents')
      }
    }
  }
</script>

<style>
  .eventWrapper {
    margin-bottom: 15px;
  }

  .firstDay {
    margin-top: 20px;
  }

  .illustrationWrapper {
    padding: 0.5rem;
    border-width: 0.5px;
    border-color: #e8e8e8;
    border-style: solid;
    box-shadow: none;
  }

  .illustrationWrapper img {
    mix-blend-mode: luminosity;
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/TodoList.vue